/* HTTP Participants repository — talks to the real backend (API_CONTRACT.md). */
import { apiDelete, apiGet, apiSend } from './httpClient'
import type { Participant, ParticipantRole } from './types'
import type { InviteParticipantInput } from './participants.mock'

export function listParticipants(tripId: string): Promise<Participant[]> {
  return apiGet<Participant[]>(`/trips/${tripId}/participants`)
}

export function inviteParticipant(tripId: string, input: InviteParticipantInput): Promise<Participant> {
  return apiSend<Participant>('POST', `/trips/${tripId}/participants`, input)
}

export function updateParticipant(
  tripId: string,
  userId: string,
  patch: { role?: ParticipantRole },
): Promise<Participant> {
  return apiSend<Participant>('PATCH', `/trips/${tripId}/participants/${userId}`, patch)
}

export function removeParticipant(tripId: string, userId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/participants/${userId}`)
}
